var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-file-toolbar-menu',{staticClass:"custom-toolbar",attrs:{"content":_vm.menu}}),_c('div',{staticClass:"scrollable"},[_c('div',{ref:"editor"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }